"use strict";

/**
 * Please note that within the scope of this monorepo there are
 * two forms of local cache coordination with respect to `localStorage`:
 *
 *  1. "cross-window", i.e. values that have their values coordinated
 * 		 and cached between @client and @launcher windows via window `postMessage`.
 * 		 For example, active chat session values like session ID in the @client
 * 		 that need to be communicated back to the @launcher in order to facilitate
 * 		 chat session resume logic.
 *
 *  2. "same-window", i.e. "normal" `localStorage` behaviour, for caching
 * 		 and retrieving values within the same window scope.
 */
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONFIG = exports.clearLocalStorage = void 0;
const cross_window_local_storage_1 = require("./cross-window-local-storage");
const same_window_local_storage_1 = require("./same-window-local-storage");
// ----------------------------------------
const clearLocalStorage = () => {
  (0, cross_window_local_storage_1.clearCrossWindowLocalStorage)();
  (0, same_window_local_storage_1.clearSameWindowLocalStorage)();
};
exports.clearLocalStorage = clearLocalStorage;
// ----------------------------------------
// Exports
var local_storage_config_1 = require("./local-storage.config");
Object.defineProperty(exports, "CONFIG", {
  enumerable: true,
  get: function () {
    return __importDefault(local_storage_config_1).default;
  }
});
__exportStar(require("./cross-window-local-storage"), exports);
__exportStar(require("./same-window-local-storage"), exports);